// @flow

import styled, { css } from 'styled-components';
import { fontFamily } from '../font-family';

export const Label = styled.label`
  font-family: ${fontFamily.sansSerif};
  font-size: 14px;
  color: #595959;

  ${props => props.kind === 'error' && css`
    color: #b12825;
  `}

  ${props => props.size === 'small' && css`
    font-size: 11px;
  `}

  ${props => props.bold && css`
    font-weight: bold;
  `}
`;
